module.exports = __webpack_public_path__ + "static/meditate-a7fefd0520e9901219fc4a9983b206d0.png";